import { TFunction } from "i18next";

import { resellerDescriptionMaxLength } from "../../types";

export type AddClientFormValues = {
    organization: string;
    expectedDevices: string;
    description: string;
};

export const validateAddClientForm = (values: AddClientFormValues, t: TFunction<["modals", "common"]>) => {
    const errors: Partial<AddClientFormValues> = {};

    if (!values.organization) {
        errors.organization = t("modals:addClient.input.organizationName.validation.required");
    }

    if (!values.expectedDevices) {
        errors.expectedDevices = t("modals:addClient.input.expectedDevices.validation.required");
    } else if (!/^\d+$/.test(values.expectedDevices)) {
        errors.expectedDevices = t("modals:addClient.input.expectedDevices.validation.invalidNumber");
    }

    if (values.description && values.description.length > resellerDescriptionMaxLength) {
        errors.description = t("common:validation.maxLength", { max: resellerDescriptionMaxLength });
    }

    return errors;
};
